// MUST match V113 chk_vnd_certifications_type CHECK.
// If this changes, update V113 (or follow-on migration) FIRST.

export const CERT_TYPES = [
  'SOC2_TYPE1',
  'SOC2_TYPE2',
  'ISO27001',
  'HITRUST_CSF',
  'PCI_DSS_ROC',
  'FEDRAMP',
  'ISO27017',
  'GDPR_ART42',
  'CSA_STAR_2',
] as const;

export type CertType = typeof CERT_TYPES[number];
